/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {SetObservationAllowedForTrainingRoomRequest} from "../model/set-observation-allowed-for-training-room-request";
import {UpdateStreamObserverStateRequest} from "../model/update-stream-observer-state-request";

@Injectable({
    providedIn: "root",
})
export class SimStreamObserverService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public getIsObservationAllowedForTrainingRoom(trainingRoomId: string) {
        return super.get<boolean>(`/api/StreamObserver/GetIsObservationAllowedForTrainingRoom`, {trainingRoomId: trainingRoomId});
    }

    public setObservationAllowedForTrainingRoom(request: SetObservationAllowedForTrainingRoomRequest) {
        return super.post<boolean>(`/api/StreamObserver/SetObservationAllowedForTrainingRoom`, request);
    }

    public updateStreamObserverState(request: UpdateStreamObserverStateRequest) {
        return super.post<boolean>(`/api/StreamObserver/UpdateStreamObserverState`, request);
    }
}